import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SettlementServiceService } from '../../../../services/raintree/Transmission/settlement-service.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-worker-view',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './worker-view.component.html',
  styleUrl: './worker-view.component.scss'
})
export class WorkerViewComponent implements OnInit{

  workerData: any[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private unsettledSErvice:SettlementServiceService,
  private dialogRef: MatDialogRef<WorkerViewComponent>
) {
    
    
  }

  ngOnInit(): void {
    this.workerData = this.data
    
  }

  closeDialog(){
    this.dialogRef.close()
  }
}
